var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v("Açıklama alanı "),_c('b',[_vm._v(_vm._s(_vm._f("numberFormat")(_vm.descriptionCount)))]),_vm._v(" kelime içermektedir. En az "),_c('u',[_vm._v("300")]),_vm._v(" kelime tavsiye edilir.")])])}
var staticRenderFns = []

export { render, staticRenderFns }